export function addToQuery(query:string, newPart: string) {
    return query + `${query.length !== 0 ? ' AND ' : ''}${newPart}`;
}